import {
  IInvoiceOptions,
  IInvoiceOptionsAccounting,
  IInvoiceOptionsBankTransactions,
  IInvoiceOptionsBilling,
  IInvoiceOptionsConnection,
  IInvoiceOptionsDocumentTemplates,
  IInvoiceOptionsItems,
  IInvoiceOptionsRounding,
  IInvoiceOptionsStocks,
  IInvoiceOptionsVat,
} from '@kinet-open-network/shared/data-access/model';

export class InvoiceOptions implements IInvoiceOptions {
  billing: IInvoiceOptionsBilling | undefined;
  connection: IInvoiceOptionsConnection | undefined;
  items!: IInvoiceOptionsItems;
  vat!: IInvoiceOptionsVat;
  accounting: IInvoiceOptionsAccounting | undefined;
  rounding: IInvoiceOptionsRounding | undefined;
  stocks: IInvoiceOptionsStocks | undefined;
  documentTemplates: IInvoiceOptionsDocumentTemplates | undefined;
  transactions: IInvoiceOptionsBankTransactions | undefined;
}
